import { useState } from 'react';
import {
  lessonCreate,
  lessonCreateSession,
  lessonCreateAutoEvaluation,
  lessonDelete,
  lessonList,
  lessonUpdate,
  lessonUpdateSession,
} from 'Api/EditCoursePage';
import { MODULE } from 'Constants/General';

const useLesson = ({
  modules,
  setModules,
  currentPositionModule,
  setCurrentPositionModule,
  setTypeContent,
  alert,
  setAlert,
}) => {
  const [currentPositionLesson, setCurrentPositionLesson] = useState(0);

  const updateStates = (newModules, alertMessage) => {
    setModules(newModules);
    setTypeContent(MODULE);
    setCurrentPositionLesson(0);
    setCurrentPositionModule(0);
    setAlert(alertMessage);
  };

  const listLesson = async ({ moduleId }) => lessonList({ moduleId });

  const addLesson = async lesson => {
    const newLesson = await lessonCreate(lesson);
    newLesson.LessonType = {};
    newLesson.LessonType.name = lesson.lessonType;

    const updatedModules = modules.map(module => {
      if (module.id !== lesson.moduleId) {
        return module;
      }

      module.lessons.pop();
      module.lessons.push(newLesson);

      return module;
    });

    return { newLesson, updatedModules };
  };

  const addLessonSession = async lesson => {
    const newLesson = await lessonCreateSession(lesson);
    newLesson.LessonType = {};
    newLesson.LessonType.name = lesson.lessonType;

    const updatedModules = modules.map(module => {
      if (module.id !== lesson.moduleId) {
        return module;
      }

      module.lessons.pop();
      module.lessons.push(newLesson);

      return module;
    });

    return { newLesson, updatedModules };
  };

  const addLessonAutoEvaluation = async lesson => {
    const newLesson = await lessonCreateAutoEvaluation(lesson);
    newLesson.LessonType = {};
    newLesson.LessonType.name = lesson.lessonType;

    const updatedModules = modules.map(module => {
      if (module.id !== lesson.moduleId) {
        return module;
      }

      module.lessons.pop();
      module.lessons.push(newLesson);

      return module;
    });

    return { newLesson, updatedModules };
  };

  // Actualizamos las lecciones actuales con los nuevos datos.
  // Si hay alguna lección recien creada sin ID, solo actualizamos la lista actual y la posición.
  const updateLesson = async ({ id, file, order, name, isDraft, isPrivate, index } = {}, newModules = null) => {
    // Si existe ID quiere decir que la lección ya esta creada, actualizamos el "order" en base de datos.
    if (id) {
      const response = await lessonUpdate({
        id,
        file,
        order,
        name,
        isDraft,
        isPrivate,
      });

      // Si existe modulos nuevos, quiere decir que se creó una nueva lección y se actualiza la lista de lecciones.
      if (newModules === null) {
        return response;
      }

      // Se actualiza la lista de lecciones del módulo actual.
      const currentModule = newModules[currentPositionModule];
      currentModule.lessons[currentPositionLesson].file = file;
      updateStates(newModules, 'AlertLessonCreatedSuccess');
    } else {
      // Actualizamos solamente los estados actuales con el modulo actual
      setCurrentPositionLesson(index);
    }

    return null;
  };

  const updateLessonData = async ({ id, file, order, name, isDraft, isPrivate, privateUsers }) => {
    await lessonUpdate({
      id,
      file,
      order,
      name,
      isDraft,
      isPrivate,
      privateUsers,
    });
    modules[currentPositionModule].lessons[currentPositionLesson].name = name;
    modules[currentPositionModule].lessons[currentPositionLesson].isDraft = isDraft;
    modules[currentPositionModule].lessons[currentPositionLesson].isPrivate = isPrivate;
    if (file) modules[currentPositionModule].lessons[currentPositionLesson].file = file;
    setModules(Array.from(modules));
    setAlert('AlertLessonUpdatedSuccess');
  };

  /**
   * Elimina la lección de la lista de lecciones del módulo actual y de la base de datos si existe.
   * @param {string} id El id de la lección a eliminar.
   */
  const deleteLesson = async id => {
    // Si hay ID quiere decir que existe registro den base de datos, se borra.
    if (id) {
      await lessonDelete(id);
      // Se actualiza la lista actual para borrar la lección.
      const filteredLessons = modules[currentPositionModule].lessons.filter(lesson => lesson.id !== id);
      // Se guarda las nuevas lección exluyendo la lección eliminada.
      modules[currentPositionModule].lessons = filteredLessons;
    } else {
      // Se busca por posición ya que no tiene ID y se elimina de la lista.
      modules[currentPositionModule].lessons.splice(currentPositionLesson, 1);
    }

    updateStates(Array.from(modules), 'AlertLessonDeleteSuccess');
  };

  const updateLessonSessionData = async ({
    id,
    order,
    name,
    isDraft,
    description,
    meetUrl,
    date,
    time,
    address,
    isPrivate,
    privateUsers,
    duration,
    isRandomQuestionOrder,
    preventTabSwitching,
    questions,
  }) => {
    console.log('duration: ', duration);

    await lessonUpdateSession({
      id,
      order,
      name,
      isDraft,
      description,
      meetUrl,
      date,
      time,
      address,
      isPrivate,
      privateUsers,
      duration,
      isRandomQuestionOrder,
      preventTabSwitching,
      questions,
    });
    modules[currentPositionModule].lessons[currentPositionLesson].name = name;
    modules[currentPositionModule].lessons[currentPositionLesson].isDraft = isDraft;
    modules[currentPositionModule].lessons[currentPositionLesson].description = description;
    modules[currentPositionModule].lessons[currentPositionLesson].meetUrl = meetUrl;
    modules[currentPositionModule].lessons[currentPositionLesson].date = date;
    modules[currentPositionModule].lessons[currentPositionLesson].time = time;
    modules[currentPositionModule].lessons[currentPositionLesson].address = address;
    modules[currentPositionModule].lessons[currentPositionLesson].isPrivate = isPrivate;
    modules[currentPositionModule].lessons[currentPositionLesson].duration = duration;
    modules[currentPositionModule].lessons[currentPositionLesson].isRandomQuestionOrder = isRandomQuestionOrder;
    modules[currentPositionModule].lessons[currentPositionLesson].preventTabSwitching = preventTabSwitching;
    setModules(Array.from(modules));
    setAlert('AlertLessonUpdatedSuccess');
  };

  return {
    addLesson,
    addLessonSession,
    addLessonAutoEvaluation,
    updateLesson,
    updateLessonSessionData,
    deleteLesson,
    updateLessonData,
    currentPositionLesson,
    setCurrentPositionLesson,
  };
};

export default useLesson;
